var map = {
	"./fig01.jpg": "4554",
	"./fig02.jpg": "94ea",
	"./fig03.jpg": "676b",
	"./fig04.jpg": "162f",
	"./fig05.jpg": "a21b",
	"./fig06.jpg": "6eb8",
	"./fig07.jpg": "6849",
	"./fig08.jpg": "da70",
	"./fig09.jpg": "f521",
	"./fig10.jpg": "5708",
	"./fig11.jpg": "c172",
	"./fig12.jpg": "14d1",
	"./fig13.jpg": "42dc",
	"./fig14.jpg": "41bd",
	"./fig15.jpg": "b633",
	"./fig16.jpg": "7bab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0135";